import React, { Component } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Input } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import axios from 'axios';
import { ROOT_API_URL } from '../../../../../api-config';
import { auth } from '../../../../../services/auth.service';

class ColorForm extends Component {
	constructor(props) {
		super(props);
        this.state = {
            disabled: false,
            colorInEdit: this.props.dataItem || null,
            originalColor: this.props.dataItem.Description || '',
            value: [],
            colorMessage: ''
		};
	}

	componentDidMount() {
		
	}

	handleSubmit = (event) => {
        event.preventDefault();

        if (this.state.disabled) {
            return;
        }
        this.setState({ disabled: true });
        if (this.state.originalColor != this.state.colorInEdit.Description) {
            axios
				.get(`${ROOT_API_URL}/ManageColors/IsColorExist?colorName=${this.state.colorInEdit.Description}`, { headers: auth.authHeader() })
                .then((response) => {
                    this.setState({
						colorMessage: response.data.message,
						disabled: false 
                    });

                    if (this.state.colorMessage == '') {
                        this.props.save({
                            ...this.state.colorInEdit
                        });
                       
                        this.props.cancel();
                    }
                })
                .catch((response) => {
                    console.log(response);
                });
        }
        else {
            this.props.save({
                ...this.state.colorInEdit
            });
            this.setState({ disabled: false });
            this.props.cancel();
        }	
	};
	isCustom(item) {
		return item.id === undefined;
	}
	addKey(item) {
		item.id = new Date().getTime();
	}
	onDialogInputChange = (event) => {
		const edited = this.state.colorInEdit;
		edited[event.target.name] = event.target.value;
		edited.isActive = true;
		this.setState({
            colorInEdit: edited,
            colorMessage: ''
		});
    };
    
    
	render() {
		return (
			<Dialog onClose={this.props.cancel}>
			{console.log(this.state,"color state")}
                {!this.state.colorInEdit.ColorOptionId ?
                    <h2 className="adjust-dist-title">Add New Color</h2> :
                    <h2 className="adjust-dist-title">Edit Color</h2>}
				<form className="user-form" onSubmit={this.handleSubmit}>
					<div className="form-group col-md-6 col-lg-4">
						<label htmlFor="Description">Color Name</label>
						<Input
							required={true}
							type="text"
							name="Description"
							id="Description"
							value={this.state.colorInEdit.Description || ''}
							onChange={this.onDialogInputChange}
                        />
                        <p className="error-message">{this.state.colorMessage}</p>
					</div>
				
					<DialogActionsBar>
                        <div className="adjust-btns">
							<div className="form-group">
								<button className="admin-k-button" onClick={this.props.cancel}>
									<i className="fas fa-times"></i>
									<span>CANCEL</span>
								</button>
                                {!this.state.colorInEdit.ColorOptionId ? (
                                    <button type="submit" className="admin-k-button" disabled={this.state.disabled}>
										<i className="fas fa-save"></i>
                                        <span>{this.state.disabled ? 'SAVING...' : 'SAVE'}</span>
									</button>
								) : (
									<button type="submit" className="admin-k-button" disabled={this.state.disabled}>
										<i className="fas fa-edit"></i>
                                        <span>{this.state.disabled ? 'UPDATING...' : 'UPDATE'}</span>
									</button>
								)}
							</div>
						</div>
					</DialogActionsBar>
				</form>
			</Dialog>
		);
	}
}

export default ColorForm;
